module.exports = __webpack_public_path__ + "static/media/snickerdoodle.0b3b223f.png";